import { FC } from "react";
import { Card } from "@traas/lib/src/components/Card";
import { Employee } from "../../../lib/src/api/dto/Employee";
import { useApi } from "../api/APIContext";
import { EmployeeAvatar } from "../personel/components/EmployeeAvatar";
import moment from "moment";
import { useLiveLocations } from "../realtime/LiveLocationContext";
import { MapWithEmployeeMarkers } from "../../../lib/src/components/content/MapWithEmployeeMarkers";

export const LiveLocation: FC = () => {
  const { employees, vehicles } = useApi();
  const { currentLocations } = useLiveLocations();

  return (
    <main className={"flex-1 overflow-y-scroll max-h-[calc(100vh-4rem)]"}>
      <div className={"mx-6 my-8"}>
        <h1 className={"h-12 flex items-center text-2xl mb-6 font-bold"}>Live Locatie</h1>
        <div className={'flex items-stretch'}>
          <div className={'flex-1 my-8 mr-4 rounded-sm shadow-sm overflow-hidden min-h-[min(70vh,800px)]'}>
            {/* Location and zoom are Traas Office with zoom that just fits Walcheren and Zuid-Beveland. */}
            <MapWithEmployeeMarkers
              center={{ lat: 51.4808111, lng: 3.8153836 }}
              zoom={11}
              markers={[
                ...(Object.values(currentLocations)
                  .map((location, index) => {
                    const emp = employees.find((e) => e.id === location.employeeId);
                    if (!emp) {
                      return null;
                    }
                    return { pos: { lat: location.lat, lng: location.lon }, angle: location.angle, employee: emp };
                  })
                  .filter((m) => m !== null) as {
                  pos: { lat: number; lng: number };
                  angle: number;
                  employee: Employee;
                }[]),
              ]}
            />
          </div>
          <Card title={"Medewerkers"}>
            Live locatie van medewerkers van vandaag.
            <div className={"text-sm"}>
              {Object.keys(currentLocations).map((employeeId, index) => {
                const emp = employees.find((e) => e.id === employeeId);
                if (!emp) {
                  return <div key={index}></div>;
                }
                const vehicle = vehicles.find((v) => v.id === currentLocations[employeeId].vehicleId);
                return (
                  <div key={index} className={"flex items-center h-16"}>
                    <div className={"-m-3"}>
                      <EmployeeAvatar employee={emp} />
                    </div>
                    <div className={"ml-3"}>
                      <div className={"font-medium"}>
                        {emp.firstName} {emp.lastName}
                      </div>
                      <div className={"flex items-center"}>
                        <div className={"text-slate-500 text-sm"}>
                          Laatste update: {moment(currentLocations[employeeId].timestamp).format("HH:mm")}
                        </div>
                        {vehicle && (
                          <div className={"ml-2 border rounded px-1.5 py-0.5 bg-yellow-400 font-medium"}>
                            {vehicle.licensePlate}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Card>
        </div>
      </div>
    </main>
  );
};
